<template>
	<div id="misDatos">

		<b-form class="mt-3" @submit.prevent="onSubmit()">

			<b-card header="Datos de personales">

				<form-signup :title="null" v-model="form" lock-email new-password-mode/>

				<div class="text-right mt-2">
					<b-button type="submit" class="btn-red btn-form" variant="primary" :disabled="(disabled || isProcessing)">
						<span v-if="isProcessing">Procesando...</span>
						<span v-else>Guardar cambios</span>
					</b-button>
				</div>

			</b-card>
		</b-form>

	</div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import formSignup from './form-signup.vue'

import { notify, swalResponse } from '@/utils.js';

// VUEX
import { mapGetters, mapMutations } from 'vuex'

export default {
	// COMPONENTS
	components: { 
		formSignup, 
	},

	// DATA
	data() {
		return {
			isProcessing: false,
			states: [],
			towns: [],
			disabled: false,
			form: null
		}
	},

	// COMPUTED
	computed: {
		...mapGetters({
            getUser: 'authGetUser'
        })
	},

	methods: {
		...mapMutations(['authUpdate']),
		async onSubmit(){
			this.isProcessing = true	
			try {
				const response = await axios.post('index.php?r=api/account/update', this.form)
				swalResponse(response)
				if(response.status)
					// alert('reload page to see changes!');
					this.authUpdate({user: response.data})
			} catch(e) {
				notify(e);
			} finally {
				this.isProcessing = false	
			}
		}
	},

	// MOUNTED
	mounted(){
		this.form = _.clone(this.getUser)
	}
}
</script>

<style lang="scss">
    @import '@/scss/app.scss';
    #misDatos {}
</style>